import { prepForSave as prepSensorsForSave } from './sensors';

export const BLANK_RULE = Object.freeze({
    custom:                    true,
    description:               '',
    enabled:                   false,
    faultLogicCode:            '',
    faultLogicXml:             '',
    formulaCode:               '',
    formulaXml:                '',
    customWeight:              '',
    customWeightEnabled:       false,
    fvoEnabledScoring:         false,
    fvoOutputDataType:         '',
    highScoreValueLimit:       '',
    issueTypes:                [],
    lowScoreValueLimit:        '',
    lowScoreBooleanValueLimit: '',
    name:                      '',
    priority:                  null,
    recommendation:            '',
    ruleAggregateDuration:     0,
    ruleAggregateType:         'None',
    ruleAggregateValue:        0,
    ruleTemplateId:            null,
    ruleType:                  null,
    sensors:                   [],
    systemEffect:              '',
    target:                    null,
    targetBuildingTypes:       [],
    targetBusinessTypes:       [],
    targetClients:             [],
    targetEquipmentTypes:      [],
    targetSites:               [],
    targetSystemTypes:         []
});

export const BLANK_RULE_TEMPLATE_ID = '0';

export const DEFAULT_RULE = Object.freeze({
    ...BLANK_RULE,
    name: 'My New Rule'
});

export function findRuleById(ruleId, rules) {
    if (ruleId === BLANK_RULE_TEMPLATE_ID) {
        return BLANK_RULE;
    }
    return (rules.data || []).find(({ id }) => id === ruleId);
}

/**
 * Performs transforms required for saving a rule
 */
export function prepForSave({ id, custom, ruleTemplateId, ...rule }) {
    if (!id) {
        id = undefined;
    }
    return {
        ...rule,
        id,
        sensors: prepSensorsForSave(rule.sensors)
    };
}

export function resetRule(ruleTemplateId, rules) {
    const rule = findRuleById(ruleTemplateId, rules);
    return {
        ...rule,
        custom:  ruleTemplateId === BLANK_RULE_TEMPLATE_ID,
        enabled: false,
        id:      null,
        ruleTemplateId
    };
}

export function getRuleFvoSensorFilterName(meta, ruleId, sensorFilterId) {
    const rule = meta.info.rules.find(r => r.id === ruleId);
    if (rule) {
        const sensorFilter = rule.sensorFilters.find(sf => sf.id === sensorFilterId);
        if (sensorFilter) {
            return sensorFilter.sensorTypeName ? sensorFilter.sensorTypeName : 'Unknown Sensor Filter';
        }
        else {
            return 'Unknown Sensor Filter';
        }
    }
    else {
        return '';
    }
}
